// extracted by mini-css-extract-plugin
export default {"navButton":"HeroNavigation_navButton__gPiJG","prevButton":"HeroNavigation_prevButton__lA5sG","nextButton":"HeroNavigation_nextButton__Qv+Ul"};